import * as React from "react";

const Calendar: React.FC = () => {
    return <svg width="21px" height="24px" viewBox="0 0 21 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
    <g id="3.-Style" stroke="currentColor" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="1.Iconography" transform="translate(-142.000000, -295.000000)" fill="currentColor">
            <g transform="translate(79.000000, 230.000000)">
                <g transform="translate(63.000000, 65.000000)" id="UI-Icon/calendar">
                    <g>
                        <path d="M0,2.23144444 L0,23.1902222 L20.9587778,23.1902222 L20.9587778,2.23144444 L0,2.23144444 Z M2.61955556,20.5706667 L2.61955556,7.47133333 L18.3392222,7.47133333 L18.3392222,20.5706667 L2.61955556,20.5706667 Z"></path>
                        <path d="M2.69811111,5.19166667 L2.69811111,0.0101111111 L5.31766667,0.0101111111 L5.31766667,5.19166667 L2.69811111,5.19166667 Z M15.7974444,5.19166667 L15.7974444,0.0101111111 L18.417,0.0101111111 L18.417,5.19166667 L15.7974444,5.19166667 Z"></path>
                    </g>
                    <polygon fillRule="nonzero" points="10.7924444 17.8888889 10.7924444 11.4488889 8.65511111 11.4488889 8.65511111 12.1115556 9.91511111 12.1115556 9.91511111 17.8888889"></polygon>
                </g>
            </g>
        </g>
    </g>
</svg>;
};

export default React.memo(Calendar);
